import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { pad } from '../utils/format';
export function Countdown() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: pad(hours),
    label: 'hs'
  }, {
    value: pad(minutes),
    label: 'min'
  }, {
    value: pad(seconds),
    label: 'seg'
  }];
  return <div className="flex items-center gap-2" role="timer" aria-live="off" data-id="element-65" data-mp="3pzknexk83610">
      {units.map(unit => <div key={unit.label} className="w-16 rounded-lg bg-forest-deep px-2 py-2.5 text-center" data-id="element-66" data-mp="3c3z1iz9ad2ct">
          <p className="font-display text-xl font-black tabular-nums text-cream" data-id="element-67" data-mp="3gyw71w7cwtky">
            {unit.value}
          </p>
          <p className="text-[10px] font-semibold uppercase tracking-wide text-cream/55" data-id="element-68" data-mp="372t78wzz9716">
            {unit.label}
          </p>
        </div>)}
    </div>;
}